import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_3: FaireProductEntity = {
  token: "matcha-3",
  type: "product",
  name: "Wholesale Bar Soap",
  brandName: "Red Soap Co",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/4f6ec3b62cbd7ffd79142e805c0d4fd82cf6cb9d6fc457cb5e1a02da942c4dc1.png",
  priceDollars: 3,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/4f6ec3b62cbd7ffd79142e805c0d4fd82cf6cb9d6fc457cb5e1a02da942c4dc1.png",
  weight: 0.3,
  dimensions: {
    width: 3,
    height: 4,
    depth: 1,
  },
  description: "Matcha-infused wholesale bar soap",
  categoryTokens: ["cat_bath-all"],
  tags: ["matcha", "soap", "wellness", "skincare", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
